import _ from "lodash";
import { useRef } from "react";

function useDebounce(
  func: (e: any) => void,
  wait: number,
  options?: _.DebounceSettings
) {
  return useRef(_.debounce(func, wait, options)).current;
}

export default useDebounce;
